export const SET_FUNDING_VALUE = 'setFundingValue';
export const SET_FUNDING_NAME = 'setFundingName';
export const SET_FUNDING_PROPERTY_ID = 'setFundingPropertyId';
export const SET_FUNDING_DESCRIPTION = 'setFundingDescription';

export const SET_FUNDING_ERROR = 'setFundingError';
